import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {
  ResultsModifiedAtQuery,
  ResultsModifiedAtQueryVariables,
} from 'lab-automation/graphql/__generated/ResultsModifiedAtQuery';
import {RESULTS_MODIFIED_AT_QUERY} from 'lab-automation/graphql/ResultsModifiedAt';
import {ResultsTable} from 'notebook/integrations/results/ResultsTableConstants';

export default function useHasOutOfDateResults(resultsTable: ResultsTable): boolean {
  const resultIds = resultsTable.rows.map((row) => row.metadata.euid).filter((id) => id != null);
  const modifiedAtQueryResult = useBenchlingQuery<ResultsModifiedAtQuery, ResultsModifiedAtQueryVariables>(
    RESULTS_MODIFIED_AT_QUERY,
    {variables: {ids: resultIds}}
  );
  return (
    modifiedAtQueryResult.type === QueryResultType.SUCCESS &&
    modifiedAtQueryResult.data.results.some(
      (result) => !isInaccessible(result) && new Date(result.modifiedAt) > new Date(result.createdAt)
    )
  );
}
